import { useState } from 'react';
import { Link } from 'react-router-dom';
import { LifeBuoy, Lock } from 'lucide-react';

import PrivacyPolicyModal from '@/components/legal/PrivacyPolicyModal';
import { Button } from '@/components/ui/button';

export default function HelpSection() {
  const [privacyOpen, setPrivacyOpen] = useState(false);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h3 className="text-sm font-semibold text-foreground">Help</h3>
        <p className="text-xs text-muted-foreground">Privacy policy and support.</p>
      </div>
      <div className="flex flex-col gap-2">
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={() => setPrivacyOpen(true)}
        >
          <Lock className="h-4 w-4 mr-2" />
          Privacy Policy
        </Button>
        <Button variant="outline" className="w-full justify-start" asChild>
          <Link to="/support">
            <LifeBuoy className="h-4 w-4 mr-2" />
            Contact Support
          </Link>
        </Button>
      </div>
      {privacyOpen && (
        <PrivacyPolicyModal mode="read" onClose={() => setPrivacyOpen(false)} />
      )}
    </div>
  );
}
